import { InputText } from 'primereact/inputtext';
import styled from 'styled-components';

export const EmailInput = styled(InputText)`
    width: 100%;
`;

export const Footer = styled.small`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;

    a {
        color: inherit;
    }
`;

export const Wrapper = styled.form`
    padding: 1em;
    margin: 5em auto 0;

    width: 100%;
    max-width: 27em;

    text-align: center;

    display: flex;
    flex-direction: column;
    gap: 1em;
`;

export const Welcome = styled.span`
    font-size: 1.2em;
`;
